import Orders from "@/Pages/Orders";
import { Suspense, lazy, useMemo } from "react";

// Lazy load components
// const AdminElderly = lazy(() => import("../Pages/Admin/AdminElderly"));
// const AdminElderlySinglePage = lazy(() => import("../Pages/Admin/AdminElderlySinglePage"));

// const SuspendedSuperAdmin = lazy(() => import("../Pages/SuperAdmin/SuspendedSuperAdmin"));

const AdminDashboard = lazy(() => import("@/Pages/AdminDashboard/index"));

const AdminUser = lazy(() => import("../Pages/AdminUser/index"));
const UserProfileView = lazy(() => import("@/Pages/UserProfileView"));
const Supportnursing = lazy(() => import("@/Pages/Supportnursing/index"));
const Supportnuser = lazy(() => import("@/Pages/Supportnuser/index"));
const SupportUserDetail = lazy(() => import("@/Pages/SupportUserDetail/index"));
const NotFound = lazy(() => import("@/Pages/NotFound/index"));
const RecentlyDeleted = lazy(() => import("@/Pages/RecentlyDeleted"));

// supporter dashboards
const SupportAgentDashboard = lazy(() =>
  import("@/Pages/Supportnursing/Dashboards/SupportAgentDashboard")
);
const NurseDashboard = lazy(() =>
  import("@/Pages/Supportnursing/Dashboards/NurseDashboard")
);
const EndUserDashboard = lazy(() =>
  import("@/Pages/Supportnursing/Dashboards/EndUserDashboard")
);

// Elderly Management
const ElderlyList = lazy(() => import("@/Pages/Elderlies/ElderlyList"));
const ElderlyProfile = lazy(() => import("@/Pages/Elderlies/ElderlyProfile"));

// Alerts
const AlertsList = lazy(() => import("@/Pages/Alerts/AlertsList"));
const AlertDetail = lazy(() => import("@/Pages/Alerts/AlertDetail"));
//Deals
const Deals = lazy(() => import("@/Pages/Deals/index"));
//Installation
const Installation = lazy(() => import("@/Pages/Installation/index"));
//Auth
const SelectRolePage = lazy(() => import("@/Pages/Login/index"));
//Refunds
const RefundsRequest = lazy(() => import("@/Pages/RefundsRequest/index"));
import { useEffect } from "react";

// Create a ProtectedRoute component
const ProtectedRoute = ({ role, children }) => {
  const loggedUserToken = ls.get("token");
  const userRole = useMemo(() => {
    if (loggedUserToken) {
      try {
        return jwtDecode(loggedUserToken)?.role;
      } catch (error) {
        if (error.name === "InvalidTokenError") {
          window.location.href = "/#/auth/login";
        }
      }
    }
    return null;
  }, [loggedUserToken]);
  useEffect(() => {
    console.log(userRole, role);
    const currentPath = window.location.hash;
    console.log(currentPath);

    // Check if the userRole is included in the role prop
    if (!role?.includes(userRole)) {
      if (
        userRole === "support_agent" &&
        !currentPath.includes("support-agent")
      ) {
        window.location.href = "#/supporter/support-agent/dashboard";
      } else if (userRole === "nurse" && !currentPath.includes("nurse")) {
        window.location.href = "#/supporter/nurse/dashboard";
      } else if (userRole === "end_user" && !currentPath.includes("end-user")) {
        window.location.href = "#/supporter/end-user/dashboard";
      } else if (
        userRole === "super_admin" &&
        !currentPath.includes("super-admin")
      ) {
        window.location.href = "#/super-admin/dashboard";
      } else if (
        (userRole === "office" ||
          userRole === "distributor" ||
          userRole === "monitoring_station" ||
          userRole === "installer" ||
          userRole === "sales_agent" ||
          userRole === "nursing_home") &&
        !currentPath.includes("support-nurnt")
      ) {
        window.location.href = "#/support-nurnt/dashboard";
      }
    }
  }, [userRole, role]);

  return role?.includes(userRole) ? children : null;
};

import ls from "store2";
import { jwtDecode } from "jwt-decode";
import DistributorDeal from "@/Pages/DistributorDeal";
import DealDetails from "@/Pages/DealDetails";
import NewDeal from "@/Pages/NewDeal";
const loggedUserToken = ls.get("token");
// Function to handle redirection based on role
const redirectToDashboard = (role) => {
  const rolePaths = {
    supports_agent: "#/supporter/support-agent",
    nurse: "#/supporter/nurse",
    end_user: "#/supporter/end-user",
    super_admin: "#/super-admin",
    office: "#/support-nurnt",
    distributor: "#/support-nurnt",
    monitoring_station: "#/support-nurnt",
    installer: "#/support-nurnt",
    sales_agent: "#/support-nurnt",
    nursing_home: "#/support-nurnt",
  };

  const basePath = rolePaths[role];
  const currentPath = window.location.hash;

  // Redirect only if the current path does not start with the base path
  if (basePath && !currentPath.startsWith(basePath)) {
    if (
      role === "end_user" ||
      role === "nurse" ||
      (role === "supports_agent" && currentPath.includes("elderlies")) ||
      currentPath.includes("alerts")
    ) {
      console.log("");

      // window.location.href = `${basePath}/dashboard`;
    } else {
      window.location.href = `${basePath}/dashboard`;
    }
  }
};

// Check token and redirect if necessary
if (loggedUserToken) {
  try {
    const decodedToken = jwtDecode(loggedUserToken);
    redirectToDashboard(decodedToken.role);
  } catch (error) {
    if (error.name === "InvalidTokenError") {
      console.error("Invalid token:", error.message);
      window.location.href = "/#/auth/login";
    }
  }
}
export const Routers = [
  {
    name: "Auth",
    path: "/",
    router: [
      {
        path: "",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <SelectRolePage />
          </Suspense>
        ),
      },
      {
        path: "*",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
    first: (
      <Suspense fallback={<div>Loading...</div>}>
        <SelectRolePage />
      </Suspense>
    ),
  },
  {
    name: "Supporter",
    path: "/supporter/",
    router: [
      {
        path: "support-agent/dashboard",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="supports_agent">
              <SupportAgentDashboard />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "nurse/dashboard",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="nurse">
              <NurseDashboard />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "end-user/dashboard",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="end_user">
              <EndUserDashboard />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "elderlies",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role={["end_user", "supports_agent", "nurse"]}>
              <ElderlyList />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "elderlies/elderly-profile/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role={["end_user", "supports_agent", "nurse"]}>
              <ElderlyProfile />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "alerts",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role={["end_user", "supports_agent", "nurse"]}>
              <AlertsList />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "alert/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role={["end_user", "supports_agent", "nurse"]}>
              <AlertDetail />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "*",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
  {
    name: "Super_Admin",
    path: "/super-admin/",
    router: [
      {
        path: "dashboard",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <AdminDashboard />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "users",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <AdminUser />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "user/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <UserProfileView />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "users/distributor-deal/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <DistributorDeal />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "users/distributor-deal/details/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <DealDetails />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "users/distributor-deal/new-deal/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <NewDeal />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "refunds-request",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <RefundsRequest />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "recently-deleted",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="super_admin">
              <RecentlyDeleted />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "*",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
  {
    name: "supernurAdmin",
    path: "/support-nurnt/dashboard/",
    router: [
      {
        path: "suspended-user",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute
              role={[
                "office",
                "distributor",
                "monitoring_station",
                "installer",
                "sales_agent",
                "nursing_home",
              ]}
            >
              <Supportnuser />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "suspended-user/:id",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute
              role={[
                "office",
                "distributor",
                "monitoring_station",
                "installer",
                "sales_agent",
                "nursing_home",
              ]}
            >
              <SupportUserDetail />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "installation",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute role="installer">
              <Installation />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "deals",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute
              role={[
                "office",
                "distributor",
                "monitoring_station",
                "installer",
                "sales_agent",
              ]}
            >
              <Deals />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "orders",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute
              role={[
                "office",
                "distributor",
                "monitoring_station",
                "installer",
                "sales_agent",
              ]}
            >
              <Orders />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "recently-deleted",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <ProtectedRoute
              role={[
                "super_admin",
                "office",
                "distributor",
                "monitoring_station",
                "installer",
                "sales_agent",
                "end_user",
                "supports_agent",
                "nurse",
                "nursing_home",
              ]}
            >
              <RecentlyDeleted />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: "*",
        Component: () => (
          <Suspense fallback={<div>Loading...</div>}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
    first: (
      <Suspense fallback={<div>Loading...</div>}>
        <ProtectedRoute
          role={[
            "office",
            "distributor",
            "monitoring_station",
            "installer",
            "sales_agent",
            "nursing_home",
          ]}
        >
          <Supportnursing />
        </ProtectedRoute>
      </Suspense>
    ),
  },
];
